import { render } from "./Accordion.vue?vue&type=template&id=2c601ca7"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/common/Accordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c601ca7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c601ca7', __exports__)) {
    api.reload('2c601ca7', __exports__)
  }
  
  module.hot.accept("./Accordion.vue?vue&type=template&id=2c601ca7", () => {
    api.rerender('2c601ca7', render)
  })

}


export default __exports__